import { render, staticRenderFns } from "./address_validation_validators.vue?vue&type=template&id=5b902e2d"
import script from "./address_validation_validators.vue?vue&type=script&lang=js"
export * from "./address_validation_validators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports